import { Pipe, PipeTransform } from '@angular/core';
import { Product, ProductCustomField } from '@scalefast/core';
import { ContentfulComparisonProduct } from 'src/app/core/interfaces/Contentful/Comparison/ContentfulComparisonProduct';
import { JebbitProduct } from 'src/app/core/interfaces/jebbit.interface';

@Pipe({
  name: 'extractBazaarvoiceID',
  standalone: true,
})
export class ExtractBazaarvoiceID implements PipeTransform {
  private bazaarvoiceIDExtractor: any = {
    Product: this.fromESWProduct,
    JebbitProduct: this.fromJebbitProduct,
    ContentfulComparisonProduct: this.fromComparisonProduct,
  };

  transform(product: Product | JebbitProduct | ContentfulComparisonProduct, type: string = 'Product'): string {
    return this.bazaarvoiceIDExtractor[type](product);
  }

  fromESWProduct(product: Product): string {
    let bvProductId: string = '';

    product?.custom_fields?.forEach((cf: ProductCustomField) => {
      if (cf.type.toLowerCase().includes('bvproductid')) {
        bvProductId = cf.value;
      }
    });

    return bvProductId;
  }

  fromJebbitProduct(product: JebbitProduct): string {
    let bvProductId: string = '';

    product?.fields?.productVariants?.forEach((variant) => {
      if (variant.fields.isBazaarVoiceIdentifier) {
        bvProductId = variant.fields.bazaarVoiceId;
      }
    });

    return bvProductId;
  }

  fromComparisonProduct(product: ContentfulComparisonProduct): string {
    let bvProductId: string = '';

    product?.productVariants?.forEach((variant) => {
      if (variant.bazaarvoiceId) {
        bvProductId = variant.bazaarvoiceId;
      }
    });

    return bvProductId;
  }
}
